import 'styles/PhotoFeed.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames/bind'
import Image from 'components/Gallery/Image'
import Camp2016PhotoFeed from 'components/Gallery/Camp2016PhotoFeed'
import ImageViewer from 'components/Gallery/ImageViewer'
import * as actions from 'actions'

class PhotoGridRow extends Component {
  constructor(props) {
    super(props)
  }

  handleImageClick(photo) {
    this.props.dispatch(actions.token.toggleModal({
      modalIsOpen: true,
      modalContent: photo
    }))
  }

  render() {
    let row = this.props.row

    if (row.type == Camp2016PhotoFeed.names.HERO) {
      return (
        <section className="hero-section">
          { row.images.map((photo, i) => {
            return (
              <Image onClick={this.handleImageClick.bind(this, photo)} photo={photo} key={photo.id + ' ' + i} highRes={true} typeOfLoading={Image.loadType.GREY} myId={photo.id} className='hero-image'/>
            )
          })}
        </section>
      )
    } else if (row.type == Camp2016PhotoFeed.names.REGULAR) {
      return (
        <section className="regular-section">
          { row.images.map((photo, i) => {
            let classes = classNames('regular-image', photo.position)
            return (
              <Image onClick={this.handleImageClick.bind(this, photo)} photo={photo} key={photo.id + ' ' + i} highRes={true} typeOfLoading={Image.loadType.GREY} myId={photo.id} className={classes}/>
            )
          })}
        </section>
      )
    } else if (row.type == Camp2016PhotoFeed.names.THEME) {
      return (
        <section className="theme-section">
          { row.images.map((photo, i) => {
            let classes = classNames('theme-image', photo.position)
            return (
              <Image onClick={this.handleImageClick.bind(this, photo)} photo={photo} key={photo.id + ' ' + i} highRes={true} typeOfLoading={Image.loadType.GREY} myId={photo.id} className={classes}/>
            )
          })}
        </section>
      )
    }

    return (null)
  }
}

PhotoGridRow.contextTypes = {
}
PhotoGridRow.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(PhotoGridRow)



// WEBPACK FOOTER //
// ./src/components/Gallery/PhotoGridRow.js